import React from 'react';
import clsx from 'clsx';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { Link as RouterLink } from "react-router-dom";
import { Formik } from 'formik';
import {
  Box,
  Checkbox,
  Button,
  FormHelperText,
  IconButton,
  InputAdornment ,
  TextField,
  makeStyles
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import useAuth from 'src/hooks/useAuth';
import useIsMountedRef from 'src/hooks/useIsMountedRef';

const useStyles = makeStyles(() => ({
  root: {},
  questions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  keep: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    color: 'rgba(24, 24, 25, 0.6)',
    fontWegit: 400,
    style: 'normal',
    lineHeight: '19.6px',

  },
  forget: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    color: '#3855B3',
    fontWegit: 400,
    style: 'normal',
    lineHeight: '19.6px',
  }
}));

const JWTLogin = ({ className, ...rest }) => {
  const classes = useStyles();
  const { login } = useAuth();
  const isMountedRef = useIsMountedRef();
  const label = { inputProps: { 'aria-label': 'Checkbox' } };

  const [values, setValues] = React.useState({
        userid: '',
        password: '',
        submit: null,
        keep: true,
        showPassword: false,
  });

  // const handleChange = (prop) => (event) => {
  //   setValues({ ...values, [prop]: event.target.value });
  // };

  const handleClickShowPassword = (userid, password) => {
    setValues({
      ...values,
      userid: userid,
      password: password,
      showPassword: !values.showPassword,
    });
    console.log(!values.showPassword);
  };

  const handleClickCheckBox = () => {
    setValues({
      ...values,
      keep: !values.keep,
    });
    console.log(!values.keep);
    
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  return (

    <Formik
      enableReinitialize  // initialValue가 변경되면 value를 다시 초기화 한다.
      initialValues={values}
      validationSchema={Yup.object().shape({
        userid: Yup.string().max(255).required('UserId is required'),
        password: Yup.string().max(255).required('Password is required')
      })}
      onSubmit={async (values, {
        setErrors,
        setStatus,
        setSubmitting
      }) => {
        try {
          await login(values.userid, values.password);

          if (isMountedRef.current) {
            setStatus({ success: true });
            setSubmitting(false);
          }
        } catch (err) {
          console.error(err);
          if (isMountedRef.current) {
            setStatus({ success: false });
            setErrors({ submit: err.message });
            setSubmitting(false);
          }
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values
      }) => (
        <form
          noValidate
          onSubmit={handleSubmit}
          className={clsx(classes.root, className)}
          {...rest}
        >
          <TextField
            error={Boolean(touched.userid && errors.userid)}
            fullWidth
            autoFocus
            helperText={touched.userid && errors.userid}
            label="UserId"
            margin="normal"
            name="userid"
            // onBlur={handleBlur}
            onChange={handleChange}
            type="text"
            value={values.userid}
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <div className={classes.headingBoxR}>
                    <img alt="Id" src="/static/login/id.svg" style={{height:'12px', width:'12px'}}/>
                  </div>
                </InputAdornment>
              ),
            }}
          />
          
          <TextField
            error={Boolean(touched.password && errors.password)}
            fullWidth
            helperText={touched.password && errors.password}
            label="Password"
            margin="normal"
            name="password"
            // onBlur={handleBlur}
            onChange={handleChange}
            type={values.showPassword ? 'text' : 'password'}
            value={values.password}
            variant="outlined"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <div >
                    <img alt="password" src="/static/login/password.svg" style={{height:'15.75px', width:'12px'}}/>
                  </div>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={() => handleClickShowPassword(values.userid,values.password)
                    }
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {values.showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          {errors.submit && (
            <Box mt={3}>
              <FormHelperText error>
                {errors.submit}
              </FormHelperText>
            </Box>
          )}
          {/* <Box className={classes.questions}>
            <Box>
              <Checkbox {...label} defaultChecked onChange={handleChange} onClick={handleClickCheckBox} name="keep" />
              <span className={classes.keep}>Keep me logged in</span>
            </Box>
            <Box >
              <RouterLink 
                to="/password-checkemail"
                style={{textDecoration: 'none'}}>
                <span className={classes.forget}>Forgot Password?</span>
              </RouterLink>
            </Box>
          </Box> */}
          <Box mt={2}>
            <Button
              color="secondary"
              disabled={isSubmitting}
              fullWidth
              size="large"
              type="submit"
              variant="contained"
            >
              Log In
            </Button>
          </Box>
          {/* <Box mt={2}>
            <Alert
              severity="info"
            >
              <div>
                Use
                {' '}
                <b>demo@devias.io</b>
                {' '}
                and password
                {' '}
                <b>Password123</b>
              </div>
            </Alert>
          </Box> */}
        </form>
      )}
    </Formik>
  );
};

JWTLogin.propTypes = {
  className: PropTypes.string,
};

export default JWTLogin;
